module.exports = __webpack_public_path__ + "static/media/stars-medals.4e72d91f.svg";